import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const VehiclePage = lazy(() => import('@cobliteam/vehicle'));

const routes = [
  {
    exact: true,
    path: Location.VEHICLES,
    component: VehiclePage,
  },
];

export default routes;
